import { Component, OnInit } from '@angular/core';
import { CtaService } from "../../_services/cta.service";

@Component({
  selector: 'bxl-av-services',
  templateUrl: 'av-services.component.html',
})
export class AvServicesComponent implements OnInit {
  initialized = false;
  constructor(public ctaService:CtaService,) { }

  ngOnInit(): void {
    this.initialized = true;
  }
}
